import themes from '../../theming/themes.js';
import React, { useContext } from 'react';
import _Icon from '../../components/Icon/index.js';
import _Button from '../../components/Button/index.js';
import CheckboxField from '../../components/Checkbox/_CheckboxField.js';
import _TableData from '../../components/Table/TableData.js';
import _TableRow from '../../components/Table/TableRow.js';
import findIndex from 'lodash/findIndex';
import { deselectFiltered, selectFiltered, deselectAll, selectAll } from './TableActions.js';
import TableContext from './TableContext.js';
import { TextInput } from '../../index.js';

var handleChange = function handleChange(column, filterColumn) {
  return function (e) {
    filterColumn(column, e.target.value);
  };
};
var TableFilterRow = function TableFilterRow(_ref) {
  var _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? [] : _ref$columns,
    filterColumn = _ref.filterColumn,
    hasSelectAll = _ref.hasSelectAll,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme,
    _ref$sortedData = _ref.sortedData,
    sortedData = _ref$sortedData === void 0 ? [] : _ref$sortedData,
    numberOfItems = _ref.numberOfItems,
    dataTestId = _ref['data-testid'];
  var _useContext = useContext(TableContext),
    dispatch = _useContext.dispatch,
    isSelectable = _useContext.isSelectable,
    clearFilters = _useContext.clearFilters,
    selected = _useContext.selected,
    filtered = _useContext.filtered,
    rowIdentifier = _useContext.rowIdentifier;
  var handleSelectFiltered = function handleSelectFiltered() {
    if (isAllFilteredSelected()) {
      dispatch(deselectFiltered(sortedData));
    } else {
      dispatch(selectFiltered(sortedData));
    }
  };
  var handleSelectAll = function handleSelectAll(e) {
    if (isAllFilteredSelected()) {
      dispatch(deselectAll());
    } else {
      dispatch(selectAll(sortedData));
    }
  };
  var isAllSelected = selected.length === numberOfItems;
  var isAllFilteredSelected = function isAllFilteredSelected() {
    return sortedData.every(function (data) {
      return findIndex(selected, function (o) {
        return o[rowIdentifier] === data._original[rowIdentifier];
      }) !== -1;
    });
  };
  var isSelectFilteredEnabled = function isSelectFilteredEnabled() {
    return filtered.length !== 0 && sortedData.length !== 0;
  };
  return /*#__PURE__*/React.createElement(_TableRow, {
    isHoverable: false,
    "data-testid": dataTestId,
    style: {
      backgroundColor: theme.palette.grayLightest
    }
  }, isSelectable ? /*#__PURE__*/React.createElement(_TableData, {
    style: {
      textAlign: 'center',
      padding: '0.5rem 0.25rem',
      border: "".concat(theme.name === 'secureSite' ? "2px solid ".concat(theme.palette.grayLighter) : null)
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      alignItems: 'center',
      display: 'flex',
      height: "".concat(theme.name === 'secureSite' ? '42px' : '47px'),
      justifyContent: 'center'
    }
  }, !hasSelectAll && /*#__PURE__*/React.createElement(_Button, {
    type: 'button',
    "data-testid": 'selectFiltered',
    onClick: handleSelectFiltered,
    disabled: !isSelectFilteredEnabled(),
    buttonType: 'secondary',
    size: 'small',
    style: {
      alignSelf: 'stretch',
      marginLeft: '.25rem',
      maxHeight: 'none',
      minWidth: '7rem'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '.25rem'
    }
  }, isAllFilteredSelected() ? 'Deselect' : 'Select', " Filtered")), hasSelectAll && /*#__PURE__*/React.createElement(CheckboxField, {
    keepState: true,
    value: isAllSelected,
    field: 'selectAll',
    label: 'Select All',
    hideLabel: true,
    onChange: handleSelectAll
  }))) : null, columns.map(function (column, index) {
    var lastColumn = index === columns.length - 1;
    return /*#__PURE__*/React.createElement(_TableData, {
      key: index,
      theme: theme,
      "aria-label": "".concat(column.id, "-filter"),
      style: {
        padding: '0.5rem 0.25rem',
        border: "".concat(theme.name === 'secureSite' ? "2px solid ".concat(theme.palette.grayLighter) : null)
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(TextInput, {
      "aria-labelledby": column.id,
      "data-testid": "".concat(column.id, "-field"),
      field: "".concat(column.id, "-field"),
      hideLabel: true,
      label: column.id,
      onChange: handleChange(column, filterColumn),
      placeholder: 'Filter by',
      skinny: true,
      theme: theme
    }), lastColumn ? /*#__PURE__*/React.createElement(_Button, {
      "aria-label": 'clear all filters',
      buttonType: 'text',
      onClick: clearFilters,
      size: 'small',
      style: {
        marginLeft: '.25rem',
        alignSelf: 'center'
      },
      title: 'clear all filters'
    }, /*#__PURE__*/React.createElement(_Icon, {
      name: 'undo',
      color: 'secondary',
      size: 'small'
    })) : null));
  }));
};
var TableFilterRow$1 = /*#__PURE__*/React.memo(TableFilterRow);

export default TableFilterRow$1;
